import { useCallback } from "react";
import { ToggleButton, ToggleButtonGroup } from "@lux/ds";
import useContent from "@@hooks/useContent";
import { TDamageTableTypes } from "@@pages/item-details/schemas/ItemReviewSchema";
import { StyledLayoutJustino } from "./CategoryTabs.styles";
interface ICategoryTabsProps {
  tab: TDamageTableTypes;
  setTab: (newTab: TDamageTableTypes) => void;
}

const CategoryTabs: React.FC<ICategoryTabsProps> = ({ tab, setTab }) => {
  const {
    content: { common, itemDetails: commonContent },
  } = useContent();

  const handleTab = useCallback(
    (newTab: TDamageTableTypes | null) => newTab !== null && setTab(newTab),
    [setTab],
  );

  return (
    <ToggleButtonGroup
      exclusive
      fullWidth
      value={tab}
      onChange={(_, value: TDamageTableTypes | null) => handleTab(value)}
      sx={{ width: "300px" }}
    >
      <ToggleButton value='damageMatrix' aria-label='left aligned'>
        <StyledLayoutJustino>{commonContent.damageMatrix}</StyledLayoutJustino>
      </ToggleButton>
      <ToggleButton value='photos' aria-label='centered'>
        <StyledLayoutJustino>{common.photos}</StyledLayoutJustino>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default CategoryTabs;
